import React from 'react'

export default function PrintText({ items, title }: any) {
    return (
        <span
            style={{
                position: "absolute",
                whiteSpace: "nowrap",
                top: items?.top,
                left: items?.left,
                fontSize: items?.size,
                // fontWeight: 600,
                display: items?.show ? "" : "none",
            }}
        >
            {title}
        </span>
    )
}
